import loadable from '@loadable/component';

export { default as AddTaskFormPopup } from './AddTaskFormPopup';
export { default as CreateTaskPopup } from './CreateTaskPopup';
export { default as NoteSidepanel } from './NoteSidepanel';
export { default as NotesCalendar } from './NotesCalendar';
export * from './utils';

export const LazyNotesCalendar = loadable(() => import('./NotesCalendar'));
